import AugustVault from "./artifacts/AugustVault"

export default {
  THESIS: "https://thesis.co",
  X: "https://twitter.com/mezonetwork",
  DISCORD: "https://discord.mezo.org",
  TELEGRAM: "https://t.me/mezonetwork",
  REDDIT: "https://www.reddit.com/r/MezoNetwork/",
  HOME: "https://mezo.org",
  DOCS: "https://info.mezo.org/",
  BLOG: "https://blog.mezo.org/",
  JOBS: "https://thesis.co/jobs",
  HODL_SCORE_DOCS: "https://info.mezo.org/mezo-portal/hodl-score",
  STBTC_DOSC_LINK: "https://info.mezo.org/stbtc",
  MIGRATIONS_DOCS: "https://blog.mezo.org/migrate-your-locked-wbtc-to-tbtc/",
  TERMS_OF_USE: "https://mezo.org/terms",
  CURVE: "https://curve.fi/#/ethereum/pools/factory-stable-ng-240/deposit",
  ACRE: "https://acre.fi/",
  STBTC_REMOVE: "https://blog.mezo.org/your-guide-to-redeeming-stbtc-deposits/",
  MATNSET_DISCORD:
    "https://discord.com/channels/1220035427952627863/1308191056507965450",
  WELCOME_TO_MATSNET: "https://blog.mezo.org/welcome-to-matsnet-alpha/",
  MATSNET_DOCS:
    "https://info.mezo.org/getting-started/mezo-matsnet-alpha-testnet",
  MATSNET_EXPLORER: "https://explorer.test.mezo.org/",
  DISCORD_SUPPORT:
    "https://discord.com/channels/1220035427952627863/1255155236830449735",
  PAMPLAND: "https://pamp.land/",
  BORROW_FAQ: "https://mezo.org/docs/users/musd",
  MEZO_FAQ: "https://info.mezo.org/resources/faqs",
  // TODO: Use the right link
  LIQUIDITY_HOW_IT_WORKS: "https://blog.mezo.org/",
  // TODO: Use the right link
  STAKING_HOW_IT_WORKS: "https://blog.mezo.org/",
  // TODO: Use the right link
  VAULT_HOW_IT_WORKS: "https://blog.mezo.org/",
  MEZO_MAINNET_IS_COMING: "https://blog.mezo.org/mezo-mainnet-is-coming/",
  AUGUST_VAULT_DEPOSIT_APP: `https://upshift-app-staging-git-august-2838-upshift-protocol.vercel.app/pools/1/${AugustVault.address}`,
  BORROW_RECOVERY_MODE:
    "https://mezo.org/docs/users/musd/concepts-and-terminology/#fixed-interest-borrowing:~:text=Critical%2520collateralization%2520ratio%2520(CCR)%253A%2520150%25.%2520When%2520the%2520TCR%2520is%2520below%2520the%2520CCR%252C%2520the%2520system%2520enters%2520Recovery%2520Mode.",
  MEZO_MAINNET: "https://mezo.org/",
  MEZO_TESTNET: "https://testnet.mezo.org",
}
